export const ehMesmoContexto = (contexto, selecao) =>
    !!contexto && !!selecao &&
    contexto.clienteId === selecao.clienteId &&
    (contexto.tenantId ?? null) === (selecao.tenantId ?? null);

export const escolherContextoInicial = (contextos, contextoSalvo) =>
    contextos.find(contexto => ehMesmoContexto(contexto, contextoSalvo)) ?? contextos[0] ?? null;

export const montarDireitoDoContexto = (contexto, direitoDoContexto) => ({
    entitlementId: direitoDoContexto.direitoId,
    entitlementName: direitoDoContexto.direitoNome,
    serviceLineId: direitoDoContexto.linhaServicoId,
    serviceLineName: direitoDoContexto.linhaServicoNomeExibicao,
    serviceLineTypeCode: direitoDoContexto.linhaServicoTipoLinhaServico,
    accountId: contexto.clienteId,
    accountName: contexto.clienteNomeFantasia,
    accountNumber: contexto.clienteCodigo,
    axtTenantId: contexto.tenantId,
    tenantCode: contexto.tenantCode,
    tenantName: contexto.tenantNomeExibicao
});

export const montarTenantsDosContextos = (contextos) =>
    contextos
        .filter(contexto => contexto.tenantId)
        .flatMap(contexto => contexto.direitos.map(direito => montarDireitoDoContexto(contexto, direito)));

export const direitoPertenceAoContexto = (contexto, direitoId) =>
    !!contexto?.direitos.some(direito => direito.direitoId === direitoId);

const normalizarNome = (nome) => (nome ?? "").trim().toLocaleLowerCase("pt-BR");

export const razaoSocialDiferenteDoNomeFantasia = (contexto) =>
    !!contexto?.clienteRazaoSocial &&
    normalizarNome(contexto.clienteRazaoSocial) !== normalizarNome(contexto.clienteNomeFantasia);

const QUANTIDADE_DIGITOS_CPF = 11;
const QUANTIDADE_DIGITOS_CNPJ = 14;

export const rotuloDocumentoDoCliente = (documento) => {
    const quantidadeDigitos = (documento ?? "").replace(/\D/g, "").length;

    if (quantidadeDigitos === QUANTIDADE_DIGITOS_CPF) return "CPF";
    if (quantidadeDigitos === QUANTIDADE_DIGITOS_CNPJ) return "CNPJ";
    return "CNPJ/CPF";
};

export const listarLinhasDeServicoDoContexto = (contexto) =>
    (contexto?.direitos ?? []).map(direito => direito.linhaServicoId?.toLowerCase());

export const contextoSemTenantComLinhaDeServico = (contexto, linhasServicoIds) =>
    !!contexto && !contexto.tenantId &&
    listarLinhasDeServicoDoContexto(contexto).some(linhaServicoId => linhasServicoIds.includes(linhaServicoId));

export const listarDireitosDoContextoParaChamado = (contexto) =>
    (contexto?.direitos ?? []).map(direito => ({
        entitlementId: direito.direitoId,
        entitlementName: `${direito.linhaServicoNomeExibicao} – ${direito.direitoNome}`,
        filialId: direito.filialId,
        accountId: contexto.clienteId,
        accountName: contexto.clienteNomeFantasia
    }));

export const navegacaoPermiteDireito = (navegacao, direitoId) =>
    !navegacao.direitosPermitidos?.length || navegacao.direitosPermitidos.includes(direitoId);

export const listarDireitosPermitidosNaRota = (contexto, navegacoesDaRota) =>
    (contexto?.direitos ?? []).filter(direito =>
        navegacoesDaRota.some(navegacao => navegacaoPermiteDireito(navegacao, direito.direitoId)));

export const escolherDireitoDaLinhaDeServico = (contexto, linhaServicoId, direitoPadraoId) =>
    (contexto?.direitos ?? []).find(direito =>
        !!linhaServicoId && direito.linhaServicoId?.toLowerCase() === linhaServicoId.toLowerCase())?.direitoId ?? direitoPadraoId;

export const ehRotaDeGestaoDeUsuarios = (caminho) => caminho.toLowerCase().startsWith("/usuarios");

export const escolherDireitoDaRota = (contexto, navegacoesDaRota, direitoAtualId) => {
    if (navegacoesDaRota.length === 0) {
        return contexto.direitos.find(direito => direito.direitoId === direitoAtualId) ?? contexto.direitos[0];
    }

    const direitoPermitido = contexto.direitos.find(direito =>
        navegacoesDaRota.some(navegacao => navegacaoPermiteDireito(navegacao, direito.direitoId)));

    return direitoPermitido ?? contexto.direitos[0];
};
